import React from 'react';

import AddControl from 'components/add_control';
import Address from './address';

interface AddressType {
  _destroy?: boolean;
  index: number;
  primary?: boolean;
}

interface Props {
  addresses: AddressType[];
  onChange: (addresses: AddressType[]) => void;
}

export default function Addresses({ addresses, onChange }: Props) {
  function addAddress() {
    onChange([...addresses, { index: addresses.length }]);
  }

  function changeAddress(changes: Partial<AddressType>, address: AddressType) {
    const updatedAddresses = [...addresses];

    if (changes.primary) {
      for (const index in updatedAddresses) {
        updatedAddresses[index] = { ...updatedAddresses[index], primary: false };
      }
    }

    updatedAddresses[address.index] = { ...updatedAddresses[address.index], ...changes };
    onChange(updatedAddresses);
  }

  return <>
    {addresses.filter(address => !address._destroy).map(address => (
      <Address
        address={address}
        key={address.index}
        onChange={changeAddress}
      />
    ))}

    <AddControl className="me-4" onClick={addAddress}>
      Add another address
    </AddControl>
  </>;
}
